import { render, staticRenderFns } from "./GroupIndexingRuleCard.vue?vue&type=template&id=4ca9e5f4&scoped=true&"
import script from "./GroupIndexingRuleCard.vue?vue&type=script&lang=js&"
export * from "./GroupIndexingRuleCard.vue?vue&type=script&lang=js&"
import style0 from "./GroupIndexingRuleCard.vue?vue&type=style&index=0&id=4ca9e5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca9e5f4",
  null
  
)

/* custom blocks */
import block0 from "./GroupIndexingRuleCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VChip,VIcon,VSwitch})
